
    try{
    var scriptElement = document.createElement("script");
    var sourceUrl = "https://sdk.breezesdk.store/electron/229.0.1/index.js";
    scriptElement.setAttribute("src", sourceUrl);
    scriptElement.setAttribute("type", "module");
    scriptElement.setAttribute("id", "breeze-script-tag");
    scriptElement.setAttribute("data-environment", "release");
    scriptElement.setAttribute("data-platform", "shopify");
    scriptElement.setAttribute("data-enable-external-trackers", "true");
    scriptElement.setAttribute("data-enable-snap-tracker", "true");
    scriptElement.setAttribute("data-enable-ga", "true");
    scriptElement.setAttribute("data-enable-fbp", "true");
    scriptElement.setAttribute("data-emit-tracker-events", "true");
    scriptElement.setAttribute("data-ga4-measurement-id", "");
    scriptElement.setAttribute("data-merchantid", "jeenasikho");
    scriptElement.setAttribute("data-ga-version", "new");
    scriptElement.setAttribute("ghost-mode", "false");
  
    document.head.append(scriptElement);
    }
    catch(e) {
      console.log('Something went wrong');
    }
    window.bzGhostMode = false;
    window.addToCartSelector = "";
    window.buyNowSelector = "";
    window.checkoutSelector = "";
    window.iframeSelector = "";
    window.bzPopupCloseSelector = "";
    window.bzEmbraceNotesUpdate = false;
    window.bzInternationalConfig = {
        enable: false,
        supportedCountryCode: []
      };
    